<script>

import {getMyCustomer, getSummaryData} from "@/api/order/other";
import {exportB2bBill} from "@/api/double/bill_hq";

export default {
  name: 'B2bSummary',
  components: {},
  mounted() {
    this.getList();
  },
  methods: {
    tableHeight(resetHeight = 0, asNumber = false) {
      const tableHeight = parseFloat(getComputedStyle(document.querySelector('body')).height.replace('px')) - 140 - resetHeight
      return asNumber ? tableHeight : asNumber + 'px'
    },
    handleSubmit() {
      this.getList()
    },
    updatePage(val) {
      this.formValue.page = val
      this.getList()
    },
    updatePageSize(val) {
      this.formValue.pageSize = val
      this.getList()
    },
    getList() {
      getMyCustomer().then(res => {
        this.customerArray = res.data.payload
        getSummaryData(this.formValue).then((res) => {
          this.tableData = res.data.payload.rows
          this.tableCount = res.data.payload.total
        })
      })

    }
  },
  data() {
    return {
      formValue: {
        timeType: 't1.create_time',
        billStatus: 'waitCharge',
        timeValue: [],
        keywords: '',
        page: 1,
        pageSize: 15,
        customerId: 0
      },
      customerArray: [],
      fields: [
        {
          type: 'index',
          minWidth: 60,
          align: 'center',
          fixed: 'left',
        },
        {
          title: '订单号',
          key: 'airwayNumber',
          align: 'center',
          minWidth: 160,
          fixed: 'left',
          render: (h, { row, column, index }) => {
            return h(
              'Button',
              {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    exportB2bBill(row.billId).then(res => {
                      window.open(res.data.payload.src)
                    })
                  }
                }
              },
              row['airwayNumber']
            )
          }
        },
        {
          title: '下单时间',
          key: 'createTime',
          align: 'center',
          minWidth: 220
        },
        {
          title: '订单类型',
          key: 'types',
          align: 'center',
          minWidth: 120
        },
        {
          title: '客户名称',
          key: 'account',
          align: 'center',
          minWidth: 140
        },
        {
          title: '报价时间',
          key: 'confirmTime',
          align: 'center',
          minWidth: 220
        },
        {
          title: '生成账单时间',
          key: 'makeBillTime',
          align: 'center',
          minWidth: 220
        },
        {
          title: '账单号码',
          key: 'billNumber',
          align: 'center',
          minWidth: 240
        },
        {
          title: '账单金额',
          key: 'totalAmount',
          align: 'center',
          minWidth: 150
        },
        {
          title: '支付时间',
          key: 'paymentTime',
          align: 'center',
          minWidth: 220
        },
        {
          title: '备注信息',
          key: 'remarks',
          align: 'center',
          minWidth: 240
        },
      ],
      tableData: [],
      tableCount: 0
    }
  },
}
</script>

<template>
  <Card :style="{height: tableHeight()}">
    <Form ref="frm" :model="formValue" :label-width="80" inline>
      <FormItem label="时间类型">
        <Select v-model="formValue.timeType" style="width:140px">
          <Option value="t1.create_time" key="t1.create_time">创建时间</Option>
          <Option value="t8.finance_time" key="t8.finance_time">报价时间</Option>
          <Option value="t9.payment_time" key="t9.payment_time">支付时间</Option>
        </Select>
      </FormItem>
      <FormItem label="时间范围">
        <DatePicker type="datetimerange" confirm placement="bottom-end" v-model="formValue.timeValue"
                    style="width: 300px" placeholder="请选择时间范围"></DatePicker>
      </FormItem>
      <FormItem label="账单状态">
        <Select v-model="formValue.billStatus" style="width:180px">
          <Option value="waitCharge" key="waitCharge">已生成账单未支付</Option>
          <Option value="charged" key="charged">已支付账单</Option>
          <Option value="waitBill" key="waitBill">未生成账单</Option>
        </Select>
      </FormItem>
      <FormItem label="客户信息">
        <Select v-model="formValue.customerId" style="width:200px" clearable>
          <Option v-for="(item, key) in customerArray" :value="item.id" :key="'CI_' + item.id">{{ item.account }} ({{ item.name }})</Option>
        </Select>
      </FormItem>
      <FormItem label="关键字">
        <Input type="text" v-model="formValue.keywords" placeholder="请输入关键字" />
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit">搜索数据</Button>
      </FormItem>
    </Form>

    <div>
      <Table border :columns="fields" :data="tableData" :height="tableHeight(150, true)"></Table>
    </div>
    <Page :total="tableCount" show-total :styles="{marginTop: '20px'}" show-sizer
          show-elevator @on-change="updatePage" @on-page-size-change="updatePageSize"
          @on-prev="updatePage" @on-next="updatePage"
          :page-size="formValue.pageSize" :page-size-opts="[15, 50, 100]" />
  </Card>
</template>

<style scoped>
.ive-table-fixed {
  margin-bottom: 10px!important;
  height: auto!important;
}
</style>
